import { supabase } from '@/lib/supabase';

const MAX_ATTEMPTS = 3;
const BASE_DELAY_MS = 2000;

/**
 * BUH (Budgetbakers User Hub) Service
 *
 * Resolves cross-product identity by looking up the user's email
 * in the Wallet API via an Edge Function.
 * Retries with exponential backoff on failure (2s → 4s).
 * Never throws — returns null on any error.
 */
export class BuhService {
  static async lookupBuhId(email: string): Promise<string | null> {
    for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
      if (attempt > 0) {
        const delay = BASE_DELAY_MS * Math.pow(2, attempt - 1);
        await new Promise((resolve) => setTimeout(resolve, delay));
      }

      const result = await BuhService.invokeLookup(email);
      if (result !== null) {
        return result;
      }
    }

    return null;
  }

  private static async invokeLookup(email: string): Promise<string | null> {
    try {
      const { data, error } = await supabase.functions.invoke('lookup-buh-id', {
        body: { email },
      });

      if (error) {
        return null;
      }

      return data?.buh_id ?? null;
    } catch {
      return null;
    }
  }
}
